import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom"; // Importation de ReactDOM pour le Portal
import {
  IconFilterCog,
  IconFilterEdit,
  IconFilterMinus,
  IconX,
} from "@tabler/icons-react";
import { Tooltip } from "@mantine/core";
import FilterRenameModal from "components/Common/FilterRenameModal";
import config from "config";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const CustomSelect = ({
  options,
  onEdit,
  onLoad,
  onDelete,
  getFilters,
  onUpdate,
  setSelectedFilter,
  selectedFilter,
  selectedOptionId,
  setSelectedOptionId,
}) => {
  const api = config.backOffice.apiName;
  const [selectedOption, setSelectedOption] = useState(selectedFilter);
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const containerRef = useRef(null); // Référence pour la box de sélection
  //Confirmation de suppression
  const [isModalOpen_1, setIsModalOpen_1] = useState(false);
  const [optionToDelete, setOptionToDelete] = useState(null);

  // Ajout de l'état pour le modal de renommage
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFilterId, setSelectedFilterId] = useState(null);
  useEffect(() => {
    setSelectedOption(selectedFilter);
  }, [selectedFilter]);
  const handleOptionClick = async (option) => {
    setSelectedOption(option);
    dispatch(setSelectedFilter(option));
    onLoad(option);

    setIsOpen(false);
  };
  const openRenameModal = (filterId) => {
    setSelectedFilterId(filterId);
    setIsModalOpen(true);
  };

  const closeRenameModal = () => {
    setSelectedFilterId(null);
    setIsModalOpen(false);
  };

  const handleRenameSuccess = () => {
    // Recharge ou met à jour la liste des filtres
    getFilters();
    toast.success("Nom du filtre mis à jour avec succès.");
  };
  const handleEdit = (option) => {
    onEdit(option);
    openRenameModal(option);
  };

  // const handleDelete = (option) => {
  //   // Désélectionner la sélection si l'option supprimée est la même
  //   if (selectedOption?.value === option.value) {
  //     handleOptionClick(null);
  //   }

  //   onDelete(option);
  //   setIsOpen(false);
  // };
  const handleDelete = (option) => {
    setOptionToDelete(option); // Stocke l'option à supprimer
    setIsModalOpen_1(true); // Ouvre la modal de confirmation
  };

  const confirmDelete = () => {
    if (optionToDelete) {
      if (selectedOption?.value === optionToDelete.value) {
        handleOptionClick(null);
      }
      onDelete(optionToDelete);
    }
    setIsModalOpen_1(false);
  };
  const handleUpdate = (option) => {
    onUpdate(option);
  };
  const handleToggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target) &&
      !event.target.closest(".custom-select-menu")
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  // Réagir aux changements de la liste des options
  useEffect(() => {
    if (selectedOption && options.length > 0) {
      const updatedOption = options.find(
        (opt) => opt.value === selectedOption.value
      );

      if (updatedOption) {
        // Si l'option existe toujours mais que son label a changé, mettre à jour
        if (updatedOption.label !== selectedOption.label) {
          setSelectedOption(updatedOption);
          dispatch(setSelectedFilter(updatedOption));
        }
      } else {
        // Si l'option sélectionnée n'existe plus, la désélectionner
        setSelectedOption(null);
        dispatch(setSelectedFilter(null));
      }
    }
    if (selectedOptionId !== null && options.length > 0) {
      const updatedOption = options?.find(
        (opt) => opt.value == selectedOptionId
      );
      if (updatedOption) {
        setSelectedOption(updatedOption);
        dispatch(setSelectedFilter(updatedOption));
        handleOptionClick(updatedOption);
      }
      setTimeout(() => {
        dispatch(setSelectedOptionId(null));
      }, 1000);
    }
  }, [options, selectedOptionId]);
  // Fonction pour calculer la position de l'élément dans le viewport
  const getPosition = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      return {
        top: rect.bottom, // Position sous l'élément de sélection
        left: rect.left,
      };
    }
    return { top: 0, left: 0 };
  };

  const position = getPosition();

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        width: "200px",
        fontFamily: "Arial, sans-serif",
      }}
      className="custom-select-menu"
    >
      {/* Modal de confirmation */}
      <Modal isOpen={isModalOpen_1} toggle={() => setIsModalOpen_1(false)}>
        <ModalHeader>Confirmation</ModalHeader>
        <ModalBody>Êtes-vous sûr de vouloir supprimer ce filtre ?</ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>
            Supprimer
          </Button>
          <Button color="secondary" onClick={() => setIsModalOpen_1(false)}>
            Annuler
          </Button>
        </ModalFooter>
      </Modal>
      <FilterRenameModal
        isOpen={isModalOpen}
        onClose={closeRenameModal}
        filterId={selectedFilterId}
        onRenameSuccess={handleRenameSuccess}
      />
      {/* Box de sélection */}
      <div
        onClick={handleToggleMenu}
        style={{
          padding: "4px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          cursor: "pointer",
          backgroundColor: "#f9f9f9",
          fontSize: "14px",
          fontWeight: "normal",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "290px",
        }}
      >
        <span
          style={{
            flex: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {selectedOption ? selectedOption.label : "Filtres enregistrés"}
        </span>
        <span style={{ fontSize: "12px", color: "#888" }}>
          ▼{" "}
          {selectedOption != null ? (
            <Tooltip label="Supprimer la sélection" withArrow position="top">
              <IconX
                style={{ cursor: "pointer" }}
                onClick={() => handleOptionClick(null)}
              />
            </Tooltip>
          ) : null}
        </span>
      </div>

      {/* Utilisation de React Portal pour le menu */}
      {isOpen &&
        ReactDOM.createPortal(
          <div
            className="custom-select-menu"
            style={{
              position: "absolute",
              top: position.top + "px", // Calcul dynamique de la position
              left: position.left + "px", // Assurez-vous que l'élément apparaît sous le bouton
              minWidth: "15%",
              border: "1px solid #ccc",
              borderRadius: "8px",
              backgroundColor: "#fff",
              zIndex: 1000,
              maxHeight: "225px",
              overflowY: options.length > 4 ? "scroll" : "auto",
              marginTop: "8px",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            {options?.length === 0 ? (
              <div
                style={{
                  padding: "12px",
                  textAlign: "center",
                  color: "#888",
                }}
              >
                Aucun filtre disponible
              </div>
            ) : (
              options?.map((option) => (
                <div
                  key={option.value}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px",
                    cursor: "pointer",
                    backgroundColor:
                      selectedOption?.value === option.value
                        ? "#f0f0f0"
                        : "#fff",
                    transition: "background-color 0.3s",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                  onClick={() => handleOptionClick(option)}
                >
                  <span style={{ flex: 1, marginRight: "20px" }}>
                    {option.label}
                  </span>
                  {/* Boutons Edit et Delete */}
                  <div style={{ display: "flex", gap: "8px" }}>
                    <Tooltip
                      label="Mettre à jour le filtre"
                      withArrow
                      position="top"
                      withinPortal
                      zIndex={9999} // Définit un z-index élevé pour le Tooltip
                    >
                      <IconFilterCog
                        onClick={(e) => {
                          e.stopPropagation(); // Empêche la sélection de l'option
                          handleUpdate(option);
                          // alert(`Enregistré`);
                        }}
                        color="green"
                      />
                    </Tooltip>

                    <Tooltip
                      label="Modifier le nom du filtre"
                      withArrow
                      position="top"
                      withinPortal
                      zIndex={9999} // Définit un z-index élevé pour le Tooltip
                    >
                      <IconFilterEdit
                        onClick={(e) => {
                          e.stopPropagation(); // Empêche la sélection de l'option
                          handleEdit(option);
                        }}
                        color="#ff8c00"
                      />
                    </Tooltip>

                    <Tooltip
                      label="Supprimer le filtre"
                      withArrow
                      position="top"
                      withinPortal
                      zIndex={9999} // Définit un z-index élevé pour le Tooltip
                    >
                      <IconFilterMinus
                        onClick={(e) => {
                          e.stopPropagation(); // Empêche la sélection de l'option
                          handleDelete(option);
                        }}
                        color="#d9534f"
                      />
                    </Tooltip>
                  </div>
                </div>
              ))
            )}
          </div>,
          document.body // Le menu sera monté dans le body du document
        )}
    </div>
  );
};

export default CustomSelect;
